import { createAction } from 'redux-act';
// add Department action
const addQualificationRequest = createAction('ADD_QUALIFICATION_REQUEST', data => data);
const addQualificationSuccess = createAction('ADD_QUALIFICATION_SUCCESS', data => data);
const addQualificationError = createAction('ADD_QUALIFICATION_ERROR');

// get Department action
const getAllQualificationRequest = createAction('GET_ALL_QUALIFICATION_REQUEST', data => data);
const getAllQualificationSuccess = createAction('GET_ALL_QUALIFICATION_SUCCESS', data => data);
const getAllQualificationError = createAction('GET_ALL_QUALIFICATION_ERROR');

// get Qualification By Parent Id || get All Quealification
const getAllQualificationsByParentIdRequest = createAction('GET_ALL_QUALIFICATIONS_BY_PARENT_ID_REQUEST', data => data);
const getAllQualificationsByParentIdSuccess = createAction('GET_ALL_QUALIFICATIONS_BY_PARENT_ID_SUCCESS', data => data);
const getAllQualificationsByParentIdError = createAction('GET_ALL_QUALIFICATIONS_BY_PARENT_ID_ERROR');

// Update Department action
const updateQualificationRequest = createAction('UPDATE_QUALIFICATION_REQUEST', data => data);
const updateQualificationSuccess = createAction('UPDATE_QUALIFICATION_SUCCESS', data => data);
const updateQualificationError = createAction('UPDATE_QUALIFICATION_ERROR');

// Delete Department action
const deleteQualificationRequest = createAction('DELETE_QUALIFICATION_REQUEST', data => data);
const deleteQualificationSuccess = createAction('DELETE_QUALIFICATION_SUCCESS', data => data);
const deleteQualificationError = createAction('DELETE_QUALIFICATION_ERROR');

// clear existing Department action
const handleClearQualificationStore = createAction('HANDLE_CLEAR_QUALIFICATION_STORE', data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    addQualificationRequest,
    addQualificationSuccess,
    addQualificationError,

    getAllQualificationRequest,
    getAllQualificationSuccess,
    getAllQualificationError,

    getAllQualificationsByParentIdRequest,
    getAllQualificationsByParentIdSuccess,
    getAllQualificationsByParentIdError,

    updateQualificationRequest,
    updateQualificationSuccess,
    updateQualificationError,

    deleteQualificationRequest,
    deleteQualificationSuccess,
    deleteQualificationError,

    handleClearQualificationStore,
    // toastMsgAction,

}